module.exports = __webpack_public_path__ + "img/ip-karten_02-r.b8dc49c9.jpg";